// Function to get country code based on IP address
async function getCountryCode() {
    try {
        const response = await fetch('https://ipinfo.io/json');
        const data = await response.json();
        return data.country;
    } catch (error) {
        console.error('Error fetching IP information:', error);
        return null;
    }
}

// Example usage
getCountryCode().then(countryCode => {
    if (countryCode && countryCode == 'US') {
  //     var new_url = `https://www.amazon.com.au/stores/FOOTFORWARD/page/BF28EEED-F2B7-401B-8FAE-2CE461D63B4D`;
  //window.location.href=`https://www.amazon.com.au/stores/FOOTFORWARD/page/BF28EEED-F2B7-401B-8FAE-2CE461D63B4D`;
      
    }
});